module.exports = __webpack_public_path__ + "img/icon_4_9.5b73e62a.png";